import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Talle } from './talle.model';

@Injectable()
export class TalleResolver implements Resolve<Talle> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(Talle);
      }
      return await this.backendService.get(Talle, Talle.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/talles']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/talle/talle.resolver.ts